// ═══════════════════════════════════════════════════════════════
//  CONFIGURATION DES SITES & ATELIERS — EMS
//  Modifier ce fichier pour ajouter / renommer des sites ou
//  activer / désactiver des ateliers par site.
// ═══════════════════════════════════════════════════════════════

// ─────────────────────────────────────────────────────────────
//  LISTE COMPLÈTE DES ATELIERS (ordre d'affichage dans le menu)
// ─────────────────────────────────────────────────────────────
export const ALL_ATELIERS = [
  "Hệ thống năng lượng",
  "Địa điểm của tôi",
  "Cảm biến",
  "PX Thiêu Kết",
  "PX Luyện Gang",
  "PX Hồ Quang",
  "PX Luyện Thép",
  "PX Cán Thép",
  "PX Khí",
]

// ─────────────────────────────────────────────────────────────
//  ATELIERS DÉSACTIVÉS PAR SITE
//  Ajouter l'id du site et la liste des ateliers à masquer.
//  Les ateliers non listés ici sont tous activés par défaut.
// ─────────────────────────────────────────────────────────────
export const SITE_DISABLED_ATELIERS = {
  // Khu Liên Hợp Hữu Nghị : pas de cán thép ni de hồ quang
  "VNHH01": ["PX Cán Thép", "PX Hồ Quang"],

  // Ajouter d'autres sites ici selon besoin :
  // "VNVC01": ["PX Khí"],
  // "VNPP01": ["PX Thiêu Kết", "PX Luyện Gang"],
}

// ─────────────────────────────────────────────────────────────
//  LISTE DES SITES
//  Champs modifiables : id, name, address, city, country,
//  typology, totalSurf, usefulSurf, energyClass, classValue,
//  consumption, co2
// ─────────────────────────────────────────────────────────────
export const SITES = [

  // ── Sites de démonstration ───────────────────────────────
  {
    id: "DEMO16",
    name: "Siège Social",
    address: "1 avenue de Paris",
    city: "Paris 75015",
    country: "FR",
    typology: "Industry",
    totalSurf: 2000, usefulSurf: 1800,
    heatedVol: "—", numberOfFloors: "—", totalVol: "—",
    energyClass: "A", classValue: 9, consumption: 4, co2: 1.7,
  },
  {
    id: "DEMO20",
    name: "Shopping Mall",
    address: "12 rue du Commerce",
    city: "Paris",
    country: "FR",
    typology: "Retail",
    totalSurf: 12000, usefulSurf: 10500,
    heatedVol: "—", numberOfFloors: "3", totalVol: "—",
    energyClass: "C", classValue: 3, consumption: 8, co2: 3.1,
  },
  {
    id: "DEMO1",
    name: "Coworking Space",
    address: "5 allée des Startup",
    city: "Lyon",
    country: "FR",
    typology: "Office",
    totalSurf: 800, usefulSurf: 750,
    heatedVol: "—", numberOfFloors: "1", totalVol: "—",
    energyClass: "B", classValue: 6, consumption: 5, co2: 2.2,
  },
  {
    id: "DEMO7",
    name: "Bonnington Res.",
    address: "14 Bonnington Square",
    city: "London",
    country: "GB",
    typology: "Residential",
    totalSurf: 3200, usefulSurf: 2900,
    heatedVol: "—", numberOfFloors: "4", totalVol: "—",
    energyClass: "B", classValue: 7, consumption: 6, co2: 2.8,
  },
  {
    id: "DEMO8",
    name: "Mall",
    address: "Viale Europa 44",
    city: "Milano",
    country: "IT",
    typology: "Retail",
    totalSurf: 8000, usefulSurf: 7200,
    heatedVol: "—", numberOfFloors: "2", totalVol: "—",
    energyClass: "D", classValue: 2, consumption: 11, co2: 4.2,
  },
  {
    id: "DEMO15",
    name: "Vasto Residence",
    address: "Via Adriatica 12",
    city: "Vasto",
    country: "IT",
    typology: "Residential",
    totalSurf: 1500, usefulSurf: 1350,
    heatedVol: "—", numberOfFloors: "5", totalVol: "—",
    energyClass: "C", classValue: 4, consumption: 7, co2: 2.9,
  },

  // ── Sites industriels Vietnam ────────────────────────────
  {
    id: "VNHH01",
    name: "Khu LH Luyện Quặng Gang Thép Hữu Nghị",
    address: "Khu Công Nghiệp Hữu Nghị",
    city: "Lạng Sơn",
    country: "VN",
    typology: "Manufacturing",
    totalSurf: 850000, usefulSurf: 620000,
    heatedVol: "—", numberOfFloors: "1", totalVol: "—",
    energyClass: "D", classValue: 2, consumption: 142, co2: 58.4,
  },
  {
    id: "VNVC01",
    name: "Khu LH Luyện Quặng, Gang, Thép & Cán Thép Vùng Cao",
    address: "Khu Công Nghiệp Vùng Cao",
    city: "Hà Giang",
    country: "VN",
    typology: "Manufacturing",
    totalSurf: 1200000, usefulSurf: 880000,
    heatedVol: "—", numberOfFloors: "1", totalVol: "—",
    energyClass: "D", classValue: 2, consumption: 198, co2: 76.1,
  },
  {
    id: "VNPP01",
    name: "Nhà Máy Luyện Phế Liệu Thép & Cán Thép Phú Phong",
    address: "Khu Công Nghiệp Phú Phong",
    city: "TP. HCM",
    country: "VN",
    typology: "Manufacturing",
    totalSurf: 320000, usefulSurf: 240000,
    heatedVol: "—", numberOfFloors: "1", totalVol: "—",
    energyClass: "C", classValue: 3, consumption: 86, co2: 31.2,
  },
]
